import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContentQuery } from "../graphql/queries";
import type {
  ContentQueryType,
  ContentQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentQuery = (
  options?: QueryHookOptions<ContentQueryType, ContentQueryVariablesType>
) => {
  return useQuery<ContentQueryType, ContentQueryVariablesType>(
    ContentQuery,
    options
  );
};
